import React from 'react';
import { Grid } from '@mui/material';
import { Text } from 'library';
import { PayBackgroundPaper } from './PayPapers';
import PaySectionHeader from './PaySectionHeader';

const ManualPayerMethods = () => {
    return (
        <PayBackgroundPaper>
            <Grid container>
                <Grid container item xs={12} justifyContent="space-between" alignItems="center">
                    <Grid item>
                        <PaySectionHeader>Payment Methods</PaySectionHeader>
                    </Grid>
                </Grid>
                <Text variant="body2" textStyle={{ marginBottom: '1.5em' }}>
                    Your account is setup to pay via ACH or check.
                </Text>
            </Grid>
        </PayBackgroundPaper>
    );
};

export default ManualPayerMethods;
